import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { AssetAndLiabilityType } from "../../types/Dossier";

export const getAssetsAndLiabilitiesTypes = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["asset-and-liability-types"],
    queryFn: (): Promise<AssetAndLiabilityType[]> => {
      return fetchWithAuth<AssetAndLiabilityType[]>(
        "getAssetsAndLiabilitiesTypes"
      );
    },
    enabled: isQueryEnabled(options),
  });
};
